import { css } from 'linaria';

const collectionMainPhotoCommon = `
    width: 100%;
    margin-top: var(--space-300);
    display: block;
  `;
export const collectionMainPhoto = {
  common: css`
    object-fit: contain;
    width: 100%;
  `,
  large: css`
    ${collectionMainPhotoCommon}
    height: 200px;
  `,
  medium: css`
    ${collectionMainPhotoCommon}
    height: 176px;
  `,
  tablet: css`
    ${collectionMainPhotoCommon}
    height: 152px;
  `,
  mobile: css`
    height: 134px;
    margin: var(--space-250) 0 0;
  `,
};
